import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    tituloEstudoGarantiaCliente,
    tituloEstudoGarantiaConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconSeguroVida,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormSeguroVida = ( { values, estudo, report, indInicial, indFinal, idClienteConjuge } ) => {
    
    let headList = [
        {
            colSpan: 8,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoCoberturaSeguroVida, report),
        },
        {
            colSpan: 3,
            headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorCS, report),
        },
        {
            colSpan: 2,
            headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorPremio, report),
        },
        {
            colSpan: 2,
            headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tempoCoberturaSeguroVida, report),
        },
    ]

    if (!idClienteConjuge) {

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaCliente(values), report
                            ),
                },
            )
        }

        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaConjuge(values), report
                            ),
                },
            )
        }

    } else {

        headList.push(
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.dataTerminoCobertura, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.statusCobertura, report),
            },
        )
    }

    const SeguroVida = () => {

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.seguroVida?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && 
                        (!idClienteConjuge || idClienteConjuge === item.familiar) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorPremio}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.tempoCoberturaSeguroVida}
                                </TableCellBodyExibeDados>
                                
                                {!idClienteConjuge && (
                                    <>
                                        {dadosCompletosCliente(values) && (
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.valorGarantiaCliente}
                                            </TableCellBodyExibeDados>
                                        )}
                                        
                                        {dadosCompletosConjuge(values) && (
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.valorGarantiaConjuge}
                                            </TableCellBodyExibeDados>
                                        )}
                                    </>
                                )}

                                {idClienteConjuge && (
                                    <>
                                        {dadosCompletosCliente(values) && (
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.dataTerminoCobertura}
                                            </TableCellBodyExibeDados>
                                        )}
                                        
                                        {dadosCompletosConjuge(values) && (
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.statusCobertura}
                                            </TableCellBodyExibeDados>
                                        )}
                                    </>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values) || idClienteConjuge
                ?
                    //<div
                    //   className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                        <SeguroVida />
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconSeguroVida}
                        label={LABEL.seguroVida}
                        helpTextMorte={HELPTEXT.estudoSeguroVida}
                        helpTextInvalidez={HELPTEXT.estudoSeguroVida}
                        component={<SeguroVida/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormSeguroVida